// sentry-console-wrapper.ts
import * as Sentry from '@sentry/react'

const originalConsoleError = console.error

console.error = (...args: any[]) => {
  originalConsoleError(...args)

  const error = args.find((arg) => arg instanceof Error)

  if (error) {
    Sentry.captureException(error)
  } else {
    const message = args
      .map((arg) => (typeof arg === 'string' ? arg : JSON.stringify(arg)))
      .join(' ')

    Sentry.captureMessage(`console.error: ${message}`, 'error')
  }
}
